// extracted by mini-css-extract-plugin
module.exports = {"popover":"AgreementsMenu_popover__6jOpW","item":"AgreementsMenu_item__F97Ft"};